import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Filters = Partial<{
  invoiceNumber: string;
  companyIds: string[];
  productIds: string[];
  expirationDateStart: string;
  expirationDateEnd: string;
  stockTypes: string[];
}>

type State = {
  filters: Filters;
  reportColumns: string[];
};

type Actions = {
  updateFilters: (filters: Filters) => void;
  updateStockTypes: (stockTypes: string[]) => void;
  updateReportColumns: (reportColumns: string[]) => void;
  clearState: () => void;
};

const getInitialState = () => ({
  filters: {},
  reportColumns: [],
});

export const useStockBalanceSearchParams = create(
  persist<State & Actions>(
    (set, get) => ({
      ...getInitialState(),
      updateFilters: (filters) => set({ filters }),
      updateStockTypes: (stockTypes) => {
        set({ filters: { ...get().filters, stockTypes } });
      },
      updateReportColumns: (reportColumns) => set({ reportColumns }),
      clearState: () => set(getInitialState()),
    }),
    {
      name: 'stock-balance-search-params-v1',
      // @ts-ignore
      partialize: (state) => ({
        reportColumns: state.reportColumns,
      }),
    }
  )
);